// A8 — THE MAIL-DIALOG OPENER. Brief 65 (brief 50 §4), the seventh of the sixteen.
//
// Building the seed `setMailDlg` takes: the people who actually have an address,
// each turned into a checked recipient row, the matter the mail is about, and
// the cc list — this matter's collaborators, minus the sender, minus anyone
// without an address.
//
//   CollectiveCaseView.tsx:4934-4952@8fdbbd6c x CollectiveCaseView.tsx:8595-8618@8fdbbd6c  78.7%
//   CaseView.tsx:1975-1990@8fdbbd6c           x CollectiveCaseView.tsx:4934-4952@8fdbbd6c  76.8%
//
// THREE COPIES, AND THE TWO THAT DIFFER MOST ARE ABOUT WHEN NOT TO OPEN IT.
// One has no empty guard; one returns early when nobody has an address; the
// third guards its single recipient and also closes the contact builder. So the
// GUARD IS NOT A PARAMETER — it stays at each call site, and this returns the
// seed rather than setting it.
//
// That is what makes the guard exact rather than approximately preserved:
// `if (!withEmail.length) return` becomes `if (!seed.persons.length) return`,
// and the two lengths are equal by construction — `persons` IS `withEmail`
// mapped. A helper that swallowed the guard would have had to choose which of
// the three behaviours to impose on the other two, which is the decision §2
// forbids.
//
// `ccCols` reads the caseObj's OWN collaborators, which is what all three did:
// the CCV copies pass `{...cs}` and then read `cs.caseCollaborators`, the same
// array by the same name.

export function mailDialogSeed(
  label: any,
  persons: any,
  caseObj: any,
  ctx: any,
) {
  const { pname, collaborators, currentUser } = ctx;
  const withEmail = persons.filter((p: any) => p && p.email);
  return {
    label,
    persons: withEmail.map((p: any) => ({
      id: p.id,
      name: pname(p),
      email: p.email,
      checked: true,
    })),
    caseObj,
    ccCols: (caseObj.caseCollaborators || [])
      .map((x: any) => collaborators.find((m: any) => m.id === x.coId))
      .filter((c: any) => c && c.id !== currentUser && c.email),
  };
}
